import Tippy from "@tippyjs/react";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";
import { LabelStatusCustom } from "../../../components/custom/label-status-custom";
import SearchCustom from "../../../components/custom/search-custom";
import { IconActive, IconEdit, IconEye, IconUnActive } from "../../../components/icons/icon-group";
import { PAGE_SIZES, STATUS } from "../../../constants/status";
import { CompaniesResponse } from "../../../models/response/companies";

interface CompaniesTableProps {
  loadingTable: boolean;
  dataCompanies: CompaniesResponse[];
  page: number;
  setPage: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  keySearch: string;
  setKeySearch: (value: string) => void;
  totalRecords: number;
  setOpenModalUpdate: (value: boolean) => void;
  setOpenModalDetail: (value: boolean) => void;
  setOpenModalChangeStatus: (value: boolean) => void;
  setDataObject: (value: CompaniesResponse) => void;
}

export const CompaniesTable = (props: CompaniesTableProps) => {
  const [tableMaxHeight, setTableMaxHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector(".navbar") as HTMLElement;
      if (header) {
        const headerHeight = header.offsetHeight;
        const remainingHeight = window.innerHeight - headerHeight - 150;
        setTableMaxHeight(remainingHeight);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="panel flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <SearchCustom value={props.keySearch} onChange={(e) => props.setKeySearch(e)} className="w-full md:w-64" />
      </div>
      <div className="datatables" style={{ height: tableMaxHeight }}>
        <DataTable
          fetching={props.loadingTable}
          withColumnBorders
          noRecordsText="No results match your search query"
          highlightOnHover
          className="whitespace-nowrap table-hover"
          records={props.dataCompanies}
          columns={[
            {
              accessor: "",
              title: "STT",
              render: (record, index) => <div>{(props.page - 1) * props.limit + index + 1}</div>,
            },
            {
              accessor: "name",
              title: "Tên công ty",
            },
            {
              accessor: "phone",
              title: "Số điện thoại",
            },
            {
              accessor: "address",
              title: "Địa chỉ",
            },
            { accessor: "created_at", title: "Ngày tạo" },
            { accessor: "updated_at", title: "Ngày cập nhật" },
            {
              accessor: "status",
              title: "Trạng thái",
              titleClassName: "!text-center",
              render: ({ status }) => (
                <LabelStatusCustom
                  content={status === 1 ? "Đang hoạt động" : "Tạm ngưng"}
                  backgroundColor={status ? "bg-green-200" : "bg-red-200"}
                  textColor={status ? "text-green-600" : "text-red-600"}
                />
              ),
              width: 150,
            },
            {
              accessor: "",
              title: "",
              titleClassName: "!text-center",
              render: ({ status, _id }) => {
                const selectedData = props.dataCompanies.find((item) => item._id === _id) as CompaniesResponse;

                return (
                  <div className="flex items-center w-max mx-auto gap-2">
                    <Tippy content="Chỉnh sửa">
                      <button
                        type="button"
                        onClick={() => {
                          props.setOpenModalUpdate(true);
                          props.setDataObject(selectedData);
                        }}
                      >
                        <IconEdit />
                      </button>
                    </Tippy>

                    <Tippy content="Chi tiết">
                      <button
                        type="button"
                        onClick={() => {
                          props.setOpenModalDetail(true);
                          props.setDataObject(selectedData);
                        }}
                      >
                        <IconEye />
                      </button>
                    </Tippy>
                    {status === STATUS.ACTIVE ? (
                      <Tippy content="Tạm ngưng">
                        <button
                          type="button"
                          onClick={() => {
                            props.setOpenModalChangeStatus(true);
                            props.setDataObject(selectedData);
                          }}
                        >
                          <IconUnActive />
                        </button>
                      </Tippy>
                    ) : (
                      <Tippy content="Bật hoạt động">
                        <button
                          type="button"
                          onClick={() => {
                            props.setOpenModalChangeStatus(true);
                            props.setDataObject(selectedData);
                          }}
                        >
                          <IconActive />
                        </button>
                      </Tippy>
                    )}
                  </div>
                );
              },
            },
          ]}
          totalRecords={props.totalRecords}
          recordsPerPage={props.limit}
          page={props.page}
          onPageChange={(p) => props.setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={props.setLimit}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) => `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`}
        />
      </div>
    </div>
  );
};
